import { render, staticRenderFns } from "./inventory-product-list.vue?vue&type=template&id=6738cae2&scoped=true&"
import script from "./inventory-product-list.vue?vue&type=script&lang=js&"
export * from "./inventory-product-list.vue?vue&type=script&lang=js&"
import style0 from "./inventory-product-list.vue?vue&type=style&index=0&id=6738cae2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6738cae2",
  null
  
)

export default component.exports